'use client';

import { useProduct } from '@/entities/product';

import { LivePetLineItem, VetRxLineItems } from './ui';

import './Specialty.scss';

export const Specialty = () => {
    const { product } = useProduct();

    const isLivePet = product?.isLivePet;
    const pharmacyData = product?.pharmacy;

    return (
        <div className="product-specialty">
            {isLivePet && <LivePetLineItem />}
            {pharmacyData && <VetRxLineItems pharmacyData={pharmacyData} />}
        </div>
    );
};
